export default __webpack_public_path__ + "static/undraw_development_ouy3-5c393c55e6d43e85a5078cdb4bcb4320.svg";